module.exports = {
  title: 'IJHDev Blog', // Required
  author: 'Ian Hayward', // Required
  description: 'The blog of a tech lead, equal parts tutorial and archive for things I have worked on.',
  additionalDescription: 'I don\'t do adverts and would rather a free crypto viewing model. If you are interested in either how that works or helping me out, click on the Brave or BitTube links below',
  primaryColor: '#00645C', // Required
  showHeaderImage: true,
  showShareButtons: true,
  postsPerPage: 6, // Required
  social: {
    website: 'mailto:me@ijh.dev',
    github: 'https://github.com/seperot',
    twitter: 'https://twitter.com/ijhdev',
    linkedin: 'https://www.linkedin.com/in/ianjhayward',
    brave: 'https://brave.com/ijh738',
    bittube: 'https://bittubeapp.com/?ref?2JQDVSX8J'
  },
  pathPrefix: '/devblog',
  siteUrl: 'https://github.com/seperot/sepe-devblog',
};
